import { useRef, useState, useEffect, useMemo, useCallback } from "react";
import Users from "./Users";
import moment from "moment";
import { ContextMenu } from "client/CommonComponents";
import { useDispatch, useSelector } from "react-redux";
import { createUser, getAllUsers, getModulesList, getUserById, setUserCreationSuccess, getUserModules, setUserById, downloadPreviousYearResult, setPreviousYearResultData, getUsersCostCenterFilterList, getUsersHomeCostCenterFilterList, getUsersLatestScoreFilterList, exportUsersAssessments, setUsersAssessmentsExcelData, getUserAttemptsById, getUserCostCentersDropDownList, getSaveUserCostCentersModules } from "Store/AssetInventory/Users/UsersAction";
import { getUsers, getUsersByEmpId } from "Store/Identity/UserProfiles/UserProfileAction";
import userProfileSelectors from '../../../../redux/UserProfile/selectors'
import { ASSET_INVENTORY } from "client/utils/constants/accessDeniedAssetInventory";
import { base64ToArrayBuffer, saveByteArray, popupInitialData } from "utils";
import _ from "lodash";
import { getSaveAssetInventoryReset, getValidateAssetInventory, setSaveAssetInventoryReset, setValidateAssetInventory } from "Store/AssetInventory/AssetInventoryReset/AssetInventoryResetAction";
import RejectedBee from "../../../assets/images/PenndingApproval/Rejected Bee.png";
import confirmationBee from "../../../assets/images/Confirmation Bee.svg";
import successBee from "../../../assets/images/Success Bee.svg";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import { useNavigate } from "react-router-dom";
import permissions, { isAuthorized } from "client/utils/Permissions";

const UsersContainer = () => {

  const [showAddUserPopup, setAddUserPopup] = useState(false)
  const [showUserAccessPopup, setShowUserAccessPopup] = useState(false)
  const [gridData, setGridData] = useState<any>([])
  const [rowData, setRowData] = useState<any>({})
  const [myUsersearchBoxValue, setMyUsersearchBoxValue] = useState<string>('')
  const [usersOption, setUserOption] = useState<any>([])
  const [userDetails, setUserDetails] = useState<any>({})
  const [userSearchText, setUserSearchText] = useState('')
  const [userUpdated, setUserUpdated] = useState<string>('')
  const [searchBy, setSearchBy] = useState<string>('name')
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const [paginationData, setPaginationData] = useState<any>({})
  const [filters, setFilters] = useState<any>({})
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [pagesCount, setPagesCount] = useState<number>(0)
  const [collapse, setCollapse] = useState({ state: false, index: '' })
  const [isClearValue, setIsClearValue] = useState(false);
  const [changedArr, setChangedArr] = useState<any>([]);

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (rowData?.userId) {
      dispatch(getUserCostCentersDropDownList(rowData?.userId, userData?.userId))
    }
  }, [rowData?.userId])

  const { usersList,
    users,
    userById,
    userData,
    userCreated,
    isValidForReset,
    isAssetInventoryRested,
    previousYearResultsData,
    userAssessmentsExcelData,
    userAttemptsById,
    usersCostCentersList,
    usersHomeCostCentersList,
    usersLatestScoresList,
      modulesList
  }: any = useSelector((state: any) => ({
    usersList: state.UsersReducer.allUsersList,
    users: state.UserProfileReducer?.users,
    userById: state.UsersReducer.userById,
    userCreated: state.UsersReducer.userCreated,
    userData: userProfileSelectors.getUserDetails(state),
    isValidForReset: state.ResetAssetInventoryReducers.isValidForReset,
    isAssetInventoryRested: state.ResetAssetInventoryReducers.isAssetInventoryRested,
    previousYearResultsData: state.UsersReducer.previousYearResultsData,
    userAssessmentsExcelData: state.UsersReducer.userAssessmentsExcelData,
    userAttemptsById: state.UsersReducer.userAttemptsById,
    usersCostCentersList: state.UsersReducer.usersCostCentersList,
    usersHomeCostCentersList: state.UsersReducer.usersHomeCostCentersList,
    usersLatestScoresList: state.UsersReducer.usersLatestScoresList,
    modulesList: state.UsersReducer.modulesList
  }))

  useEffect(() => {
    if (userData?.permissions?.length > 0 && (!isAuthorized(permissions.Assign_Users) && !isAuthorized(permissions.View_Users))) {
          navigate('/assetinventory/blank');
    }
  }, [userData?.permissions])

  const filterObj = useMemo(() => ({
    pageNumber: (paginationData?.pageIndex ?? 0) + 1,
    pageSize: (paginationData?.pageSize ?? 10),
    loggedInMail: userData?.emailId,
    columnFilters: Object.entries(filters)
      .reduce((a: any[], [key, value]) =>
        (value ? a.concat({ 'field': key, 'value': value }) : a), []),
    onlyActive: true
  }), [filters, paginationData, userData?.emailId])

  useEffect(() => {
    dispatch(getModulesList())
    dispatch(getUsers(''))
    dispatch(getUsersCostCenterFilterList())
    dispatch(getUsersHomeCostCenterFilterList())
    dispatch(getUsersLatestScoreFilterList())
  }, [])

  useEffect(() => {
    if (usersList?.data?.length) {
      const updatedUserList = usersList?.data?.map((item: any) => ({
        ...item,
        updatedDate: moment(item.updatedDate).format("MM/DD/YYYY"),
        employeeId: item?.employeeId ?? "0",
        latestStatus: item?.latestStatus ?? '-'
      }));
      setGridData(updatedUserList);
      let pageSize = paginationData?.pageSize || 10
      let tempPageCount = usersList?.totalRecords > pageSize ? Math.ceil(usersList?.totalRecords / pageSize - 1) : 0
      setPagesCount(tempPageCount)
      setTotalRecords(usersList?.totalRecords)
    } else {
      setGridData([]);
      setPagesCount(0)
      setTotalRecords(0)
    }
  }, [JSON.stringify(usersList)])

  const globalDebounce = useDebounce(myUsersearchBoxValue, 700)
  useEffect(() => {
    if (userData?.emailId) {
      dispatch(getAllUsers({ ...filterObj, globalSearch: globalDebounce ?? '' }))
    }
  }, [filterObj, globalDebounce, userData?.emailId])

  useEffect(() => {
    if (users?.length) {
      const optionsTemp = users?.map((user: any) => ({ ...user, label: user.text, value: user.value, key: user.value, text: user?.text, emailId: user?.value }))
      setUserOption(optionsTemp)
    }
  }, [JSON.stringify(users)])

  useEffect(() => {
    if (userCreated === 'success' && showAddUserPopup) {
      setTimeout(() => {
        hidePopup()
        dispatch(getAllUsers(filterObj))
      }, 1200)
    }
  }, [userCreated])

  useEffect(() => {
    if (userUpdated === 'success') {
      setTimeout(() => {
        UserAccesshidePopup()
        dispatch(getAllUsers(filterObj))
      }, 1200)
    }
  }, [userUpdated])

  const exportData = (data: any, fileName: string, reduxAction: (value: string) => void) => {
    const byteArray = base64ToArrayBuffer(data)
    saveByteArray(fileName, byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    dispatch(reduxAction(''))
  }

  useEffect(() => {
    if (previousYearResultsData === 'No Data Found' || userAssessmentsExcelData === 'No Data Found') {
      setPopupcontent({
        ...Popupcontent,
        title: "INFORMATION",
        titleImg: RejectedBee,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: "No data available to download",
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isCompletedReportVisible: false,
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setPreviousYearResultData(''))
          dispatch(setUsersAssessmentsExcelData(''))
        }
      });
    } else if (previousYearResultsData) {
      exportData(previousYearResultsData, 'previous_year_user_results', setPreviousYearResultData)
    } else if (userAssessmentsExcelData) {
      exportData(userAssessmentsExcelData, 'user_assessments', setUsersAssessmentsExcelData)
    }
  }, [previousYearResultsData, userAssessmentsExcelData])

  const CustomCell = (rowData: any) => {
    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const onShowContextualMenu = (ev: React.MouseEvent<HTMLElement>) => {
      ev.preventDefault(); // don't navigate
      setShowContextualMenu(true);
    }

    const menuItems = [
      {
        key: 'Edit',
        text: 'Edit Module',
        onClick: () => {
          setRowData(rowData)
          setShowUserAccessPopup(true)
        }
      }
    ]

    const onHideContextualMenu = () => setShowContextualMenu(false);
    const linkRef = useRef(null);
    return (
      <ContextMenu
        items={menuItems}
        hidden={showContextualMenu}
        target={linkRef}
        onItemClick={onHideContextualMenu}
        onDismiss={onHideContextualMenu}
        className='grid-context-menu'
       data-attribute="Users_container_Default_ContextMenu">
        <a className="context-menu" ref={linkRef} href="/" onClick={onShowContextualMenu}><span className='fa fa-ellipsis-h'> </span> </a>
      </ContextMenu>
    )
  }

  const handleOrderClearSelectFilter = (search: any, value: any) => {
    search(undefined);
    value.current = "";
  };

  const AddUserClick = () => {
      setAddUserPopup(true)
  }

  const hidePopup = () => {
    setAddUserPopup(false)
    setUserDetails({})
    setUserSearchText('')
    dispatch(setUserCreationSuccess(''))
    dispatch(setUserById(''))
    setUserUpdated('')
  }

  const validateAddUser = (payload: any) => {
    let isValid = true
    if (payload.isuserassignedtoassessmentmodule) {
      setUserDetails((prev: any) => ({ ...prev, userError: 'User already Exists' }))
      isValid = false
    }

    if (payload?.value === null || payload?.value === undefined || payload?.value === '') {
      setUserDetails((prev: any) => ({ ...prev, userError: 'Please select user' }))
      isValid = false
    }

    if (payload?.error) {
      setUserDetails((prev: any) => ({ ...prev, userError: `${payload?.error}, Please select valid user` }))
      isValid = false
    }
    return isValid
  }

  const addUser = () => {
    const isValid = validateAddUser({ ...userDetails.userName, ...userById })
    if (isValid) {
      const payload: any = {}
      payload.modules = [{
        "moduleId": ASSET_INVENTORY.ASSET_INVENTORY_TRAINING,
        "isActive": true
      }]
      payload.userId = 0
      payload.employeeId = userDetails?.userName?.employeeId
      payload.emailId = userDetails?.userName?.emailId
      payload.firstName = userDetails?.userName?.firstName
      payload.lastName = userDetails?.userName?.lastName
      payload.costCenter = userById?.costcenterid?.toString()
      payload.isActive = true
      payload.savedBy = userData?.emailId
      dispatch(createUser(payload))
    }
  }

  const UserAccesshidePopup = () => {
    setShowUserAccessPopup(false)
    setUserUpdated('')
    setRowData({})
    setIsClearValue(true);
  }

  const onSearchUser = useCallback((e: any, isKeyPressed?: any) => {
    const searchValue = isKeyPressed ? e : e?.target?.value ?? e ?? ''
    setMyUsersearchBoxValue(searchValue)
  }, [])

  useEffect(() => {
    document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, []);

  const onChangeUserName = (value: any) => {
    setUserDetails((prev: any) => ({ ...prev, userName: value, userError: '' }))
    dispatch(getUserById(value?.emailId, value?.homeCostCenter))
    dispatch(setUserCreationSuccess(''))
    setUserSearchText('')
    dispatch(getUsers(''))
  }

  const searchUser = (input: string) => {
    return (searchBy === 'name' ? getUsers(input) : getUsersByEmpId(input))
  }

  const filterOptionUser = (value: any, action: any) => {
    if (action.action === "input-change") {
      setUserSearchText(value)
      if (value?.length >= 3) {
        dispatch(searchUser(value))
      } else if (!value) {
        dispatch(getUsers(''))
      }
    }
  }

  const userSelectOnBlur = () => {
    setUserSearchText('')
  }
  const onChangeSearchBy = (e: any, option: any) => {
    setSearchBy(option?.key)
  }

  const donwloadPrevYearResults = () => {
    dispatch(downloadPreviousYearResult())
  }

  const hideDialog = () => setPopupcontent({ ...Popupcontent, isDialogVisible: false });

  const popupPrimarybtnOnclick = (
    item: any,
    comment: string,
    actionby: string,
    value: any
  ) => {
    dispatch(getSaveAssetInventoryReset({
      savedBy: userData?.emailId,
      comments: comment
    }));
    hideDialog();
    dispatch(setValidateAssetInventory({}))
  };

  const onClickResetAssetInventory = (e: any) => {
    e.preventDefault();
    dispatch(getValidateAssetInventory());
  }

  const setCommonPopup = (title?: any, beeImage?: any, subText?: any, isValidatePopup?: any) => {
    setPopupcontent({
      ...Popupcontent,
      title: title,
      titleImg: beeImage,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: subText,
      outlineBtnText: "Ok",
      isSingleConfirmationBtn: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      popupOutlinebtnOnclick: () => {
        hideDialog();
        if (isValidatePopup) {
          dispatch(setValidateAssetInventory({}))
        } else {
          dispatch(setSaveAssetInventoryReset(null))
        }
      }
    });
  }

  useEffect(() => {
    if (isValidForReset?.isValid && isValidForReset?.hasOwnProperty('isValid')) {
      setPopupcontent({
        ...Popupcontent,
        title: "CONFIRMATION",
        titleImg: RejectedBee,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: isValidForReset?.validationMessage ?? "Are you sure want to reset all users from the prior Asset Inventory year?",
        primaryBtnText: "Yes",
        outlineBtnText: "No",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: true,
        isCommentBoxRequire: false,
        isCompletedReportVisible: false,
        actionby: "CancelOrderBtn",
        href: "/ordermanagement",
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setValidateAssetInventory({}))
        }
      });
    } else if (!isValidForReset?.isValid && isValidForReset?.hasOwnProperty('isValid')) {
      setCommonPopup("CONFIRMATION", confirmationBee, isValidForReset?.validationMessage, true)
    } else if (isValidForReset?.error) {
      setCommonPopup("ERROR", confirmationBee, "Error occured while validating Asset Inventory Reset. Please try again.", true)
    }
  }, [isValidForReset]);

  useEffect(() => {
    if (isAssetInventoryRested && isAssetInventoryRested !== null) {
      setCommonPopup("SUCCESS", successBee, 'Asset Inventory has been reset successfully', false)
    } else if (!isAssetInventoryRested && isAssetInventoryRested !== null) {
      setCommonPopup("ERROR", confirmationBee, 'Error occured while resetting Asset Inventory. Please try again.', false)
    }

  }, [isAssetInventoryRested])

  const setGridFilters = (value: any) => {
    if (JSON.stringify(value) !== '{}') {
      setFilters((prev: any) => ({ ...prev, ...value }))
    }
  }

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      setPaginationData(fetchData.data)
    }
  }, [])

  const handleUpdateFilter = (value: any, dateRef: any, name: string) => {
    setFilters((prev: any) => ({ ...prev, [name]: name === "updatedDate" ? moment(value).format('YYYY-MM-DD') : value.value }))
    dateRef.current = name === "updatedDate" ? value : value.label;
  }

  const handleClearFilter = (fieldRef: any, name: string, value: any) => {
    setFilters((prev: any) => ({ ...prev, [name]: "" }))
    fieldRef.current = value;
  }

  const onExportExcel = (e: any) => {
    e.preventDefault();
    dispatch(exportUsersAssessments(filterObj));
  }

  const getUserAttempts = (userId: any, targetId: string) => {
    setCollapse({ state: true, index: targetId })
    dispatch(getUserAttemptsById(userId))
  }

  const closeCallout = () => {
    setCollapse({ state: false, index: '' })
  }


  const onClickAddUserByCostCenter = () => {
    navigate('/assetinventory/addUserBycostCenter');
  }

  const onClickBranchAdminAccess = (e: any) => {
    e.preventDefault();
    navigate('/assetinventory/branchAdminAccess');
  }

  const onSubmitUserAccess = () => {
    let payload: any = {};
    let userCostCentersTemp: any = [];
    changedArr?.map((item?: any) => {
      userCostCentersTemp.push({
        costCenterId: parseInt(item?.costCenterId),
        isAssetTraining: item?.isAssetTraining,
        isAssetInventory: item?.isAssetInventory,
        isMAScanning: item?.isMAScanning,
        isAssetMaintenance: item?.isAssetMaintenance,
      });
    });
    payload = {
      userId: parseInt(rowData?.userId),
      savedBy: userData?.emailId,
      inventoryCostCenters: userCostCentersTemp,
    };
    dispatch(getSaveUserCostCentersModules(payload));
  };

  const val = useMemo(() => {
    return changedArr
  }, [changedArr])

  return <Users
    AddUserClick={AddUserClick}
    CustomCell={CustomCell}
    handleOrderClearSelectFilter={handleOrderClearSelectFilter}
    showAddUserPopup={showAddUserPopup}
    hidePopup={hidePopup}
    showUserAccessPopup={showUserAccessPopup}
    UserAccesshidePopup={UserAccesshidePopup}
    gridData={gridData}
    rowData={rowData}
    onSearchUser={onSearchUser}
    myUsersearchBoxValue={myUsersearchBoxValue}
    addUser={addUser}
    usersOption={usersOption}
    userDetails={userDetails}
    onChangeUserName={onChangeUserName}
    filterOptionUser={filterOptionUser}
    userSelectOnBlur={userSelectOnBlur}
    userSearchText={userSearchText}
    userById={userById}
    userCreated={userCreated}
    userUpdated={userUpdated}
    searchBy={searchBy}
    onChangeSearchBy={onChangeSearchBy}
    donwloadPrevYearResults={donwloadPrevYearResults}
    onClickResetAssetInventory={onClickResetAssetInventory}
    Popupcontent={Popupcontent}
    popupPrimarybtnOnclick={popupPrimarybtnOnclick}
    paginationData={paginationData}
    setGridFilters={setGridFilters}
    totalRecords={totalRecords}
    fetchAction={fetchAction}
    pagesCount={pagesCount}
    filters={filters}
    handleUpdateFilter={handleUpdateFilter}
    handleClearFilter={handleClearFilter}
    usersCostCentersList={usersCostCentersList}
    usersHomeCostCentersList={usersHomeCostCentersList}
    usersLatestScoresList={usersLatestScoresList}
    modulesList={modulesList}
    onExportExcel={onExportExcel}
    collapse={collapse}
    getUserAttempts={getUserAttempts}
    userAttemptsById={userAttemptsById}
    closeCallout={closeCallout}
    onClickAddUserByCostCenter={onClickAddUserByCostCenter}
    onClickBranchAdminAccess={onClickBranchAdminAccess}
    userData={userData}
    setIsClearValue={setIsClearValue}
    isClearValue={isClearValue}
    setChangedArr={setChangedArr}
    changedArr={changedArr}
    onSubmitUserAccess={onSubmitUserAccess}
    val={val}
    setShowUserAccessPopup={setShowUserAccessPopup}
    filterObj = {filterObj}
  />
}

export default UsersContainer;